var makeString = require('./helper/makeString');

module.exports = function(str, substr) {
  str = makeString(str);
  substr = makeString(substr);

  if (str.length === 0 || substr.length === 0) return 0;
  
  return str.split(substr).length - 1;
};



//////////////////
// WEBPACK FOOTER
// ./~/underscore.string/count.js
// module id = 2259
// module chunks = 0